import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { AccountSelectors, ModulesSelectors } from '@serviceos-ng/core';

@Component({
    selector: 'serviceos-web-member',
    templateUrl: './member.component.html',
    styleUrls: ['./member.component.scss'],
})
export class MemberComponent {
    @Select(ModulesSelectors.getModuleByName('membership'))
    membershipConfig$!: Observable<any>;

    @Select(AccountSelectors.membership)
    membership$!: Observable<any>;

    constructor() {}
}
